export const VIDEO_COVER_TYPES = {
  UPLOADED: "uploaded",
  FRAME_SELECTED: "frame_selected",
  PLATFORM_DEFAULT: "platform_default",
} as const;

export const VIDEO_COVER_TIMESTAMPS = {
  UPLOADED_COVER: -1,
  DEFAULT_FRAME: 0,
} as const;

export type VideoCoverType =
  (typeof VIDEO_COVER_TYPES)[keyof typeof VIDEO_COVER_TYPES];
